import { PartnerCenterEnrollmentStatus } from "@gamedev-web/one-gaming-crm";

import { IdXboxFormsResponse } from "../../server/crm/api/models/forms";
import { FieldOption } from "../../server/edsApi/models/forms";
import { OnboardingRootState } from "../reducers/rootReducer";
import { getCurrentProgramData } from "./programsSelectors";
import { getXboxOnboardData } from "./xboxOnboardSelectors";

const getStudio = (state: OnboardingRootState) =>
  (getCurrentProgramData(state) as IdXboxFormsResponse)?.studio;

export const getIsEmbargoedCountry = (state: OnboardingRootState): boolean | undefined =>
  getStudio(state)?.isEmbargoedCountry;

export const getSellerID = (state: OnboardingRootState): string => getStudio(state)?.sellerID;

export const getPartnerCenterEnrollmentStatus = (
  state: OnboardingRootState
): PartnerCenterEnrollmentStatus => getStudio(state)?.partnerCenterEnrollmentStatus;

export const getOrdersInfoArray = (state: OnboardingRootState): Array<FieldOption> | undefined =>
  getXboxOnboardData(state)?.ordersInfo?.ordersInfoArray;
